import styled from 'styled-components/macro';
import { IFRAME_EDITOR_MODE_HEIGHT } from './constants';
export const IframeStyled = styled.iframe `
  height: ${({ isInEditor }) => (isInEditor ? `${IFRAME_EDITOR_MODE_HEIGHT}` : `100vh;`)}}
`;
